import PreferencesPage from './PreferencesPage.component';

export default PreferencesPage;